export const selectFilteredContacts = (state) => state.filters.name;
// export const selectFilter = (state) => state.filter;